export enum TabTypes {
  Home,
  Stats,
  Topics,
  QBank,
  Library,
  Videos,
  Chat,
  Games,
  FlashcardDecks,
  SelfAssessments,
  Webinar,
  Account,
  Help,
  null,
  // Appended, so the existing members keep their values (ORA-735).
  AudioOverviews,
  /** The course student's module list (Courses V1). */
  Modules,
  /** The course student's knowledge map, open on the desktop (Courses V1). */
  KnowledgeMap,
}

export enum ContentType {
  QBank = 'qbank',
  Flashcards = 'flashcards',
  Videos = 'videos',
}
